import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { PlatformLocation, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID, TransferState, inject, makeStateKey, signal } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class HelperService {
    @Inject(PLATFORM_ID) platformId: object = inject(PLATFORM_ID);
    location = inject(PlatformLocation);

    public isMobile = signal(false);
    public subDomain = signal('');
    transferState = inject(TransferState);
    breakPointObserver = inject(BreakpointObserver);
    private destroy = new Subject<void>();

    constructor() {
        this.breakPointObserver.observe('(max-width: 800px)').pipe(
            takeUntil(this.destroy)
        ).subscribe((state: BreakpointState) => {
            this.isMobile.set(state.matches);
        });
    }

    ngOnDestroy() {
        this.destroy.next();
        this.destroy.complete();
    }

    getLocation() {
        return this.location;
    }

    setStorage<T>(type: string, key: string, value: T) {
        if (isPlatformBrowser(this.platformId)) {
            const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
            if (type === 'local') localStorage.setItem(key, stringValue);
            else if (type === 'session') sessionStorage.setItem(key, stringValue);
        }
        else {
            const transferKey = makeStateKey<T>(key);
            this.transferState.set(transferKey, value);
        }
    }

    removeFromStorage(type: string, key: string) {
        if (isPlatformBrowser(this.platformId)) {
            if (type === 'local') localStorage.removeItem(key);
            else if (type === 'session') sessionStorage.removeItem(key);
        }
        else {
            const transferKey = makeStateKey<unknown>(key);
            this.transferState.remove(transferKey);
        }
    }

    getStorage<T>(type: string, key: string): T | null {
        let value: T | null = null;

        if (isPlatformBrowser(this.platformId)) {
            let rawValue: string | null = null;
            if (type === 'local') rawValue = localStorage.getItem(key);
            else if (type === 'session') rawValue = sessionStorage.getItem(key);
            
            if (rawValue) {
                try {
                    value = JSON.parse(rawValue) as T;
                } catch {
                    value = rawValue as unknown as T;
                }
            }
        } else {
            const transferKey = makeStateKey<T>(key);
            value = this.transferState.get(transferKey, null);
        }
        
        return value;
    }
};
